export const scrollParentY = (node) => {
    if (!node || !node.parentElement) {
        return null;
    }
    const style = window.getComputedStyle(node);
    const isScrollable = style.overflowY !== 'hidden' && node.scrollHeight > node.clientHeight;
    if (isScrollable) {
        if (node === document.body || node === document.documentElement) {
            return null;
        }
        return node;
    }

    return scrollParentY(node.parentElement);
};

export const scrollParentX = (node) => {
    if (!node || !node.parentElement) {
        return null;
    }
    const style = window.getComputedStyle(node);
    const isScrollable = style.overflowX !== 'hidden' && node.scrollWidth > node.clientWidth;

    if (isScrollable) {
        if (node === document.body || node === document.documentElement) {
            return null;
        }
        return node;
    }

    return scrollParentX(node.parentElement);
};
export const scrollParent = (element, includeHidden) => {
    let style = window.getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

    if (style.position === 'fixed') {
        return document.body;
    }
    for (let parent = element; (parent = parent.parentElement); ) {
        style = window.getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') {
            continue;
        }
        if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) {
            return parent;
        }
    }
    return document.body;
};
